module.exports = "<lightbox :open=open :title=title.value :loading=loading><div slot=Lightbox__body><slot name=content></slot></div></lightbox>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/containers/modal.vue
// module id = 413
// module chunks = 0